import { useState } from "react";
import { useNavigate } from "react-router-dom";

const tabs = ["Active", "Cancelled", "Offers"];

const applications = {
  Active: [
    {
      course: "Master Of Science In Data Science & Artificial Intelligence",
      university: "University of Liverpool",
      country: "UK",
      fee: "Waived",
      stage: "Offer Acceptance (Condition Complete)",
    },
    {
      course: "MSC Cyber Security",
      university: "Algoma University",
      country: "UK",
      fee: "Pending",
      stage: "University Submission (Condition Complete)",
    },
    {
      course: "Master Of Science In Data Science & Artificial Intelligence",
      university: "University of Liverpool",
      country: "Canada",
      fee: "Paid",
      stage: "Offer Acceptance (Condition Complete)",
    },
    {
      course: "MSC Cyber Security",
      university: "Algoma University",
      country: "USA",
      fee: "Pending",
      stage: "Offer Acceptance (Condition Complete)",
    },
  ],

  Cancelled: [
    {
      course: "Master Of Science In Data Science & Artificial Intelligence",
      university: "University of Liverpool",
      country: "UK",
      intake: "Jan-2026",
      status: "Offer Acceptance (Condition Complete)",
    },
    {
      course: "MSC Cyber Security",
      university: "Algoma University",
      country: "UK",
      intake: "Dec-2025",
      status: "University Submission (Condition Complete)",
    },
    {
      course: "Master Of Science In Data Science & Artificial Intelligence",
      university: "University of Liverpool",
      country: "Canada",
      intake: "Apr-2026",
      status: "Offer Acceptance (Condition Complete)",
    },
    {
      course: "MSC Cyber Security",
      university: "Algoma University",
      country: "USA",
      intake: "Apr-2026",
      status: "Offer Acceptance (Condition Complete)",
    },
  ],

  Offers: [
    {
      course: "Master Of Science In Data Science & Artificial Intelligence",
      university: "University of Liverpool",
      country: "UK",
      intake: "Jan-2026",
      expiry: "Jan-2026",
      fee: "Waived",
      stage: "University Submission (Condition Complete)",
    },
    {
      course: "MSC Cyber Security",
      university: "Algoma University",
      country: "UK",
      intake: "Dec-2025",
      expiry: "Dec-2025",
      fee: "Pending",
      stage: "University Submission (Condition Complete)",
    },
    {
      course: "Master Of Science In Data Science & Artificial Intelligence",
      university: "University of Liverpool",
      country: "Canada",
      intake: "Apr-2026",
      expiry: "Apr-2026",
      fee: "Paid",
      stage: "Offer Acceptance (Condition Complete)",
    },
    {
      course: "MSC Cyber Security",
      university: "Algoma University",
      country: "USA",
      intake: "Apr-2026",
      expiry: "Apr-2026",
      fee: "Pending",
      stage: "Offer Acceptance (Condition Complete)",
    },
  ],
};

const countryCodeMap = {
  UK: "gb",
  USA: "us",
  Canada: "ca",
};

const FeeBadge = ({ value }) => {
  const styles = {
    Waived: "bg-[#E3EDFF] text-[#1E1EAF] ",
    Paid: "bg-[#DEFFEC] text-[#044B36]",
    Pending: "bg-[#FFF0E0] text-[#825100]",
  };

  return (
    <span
      className={`px-3 py-1 text-xs font-semibold rounded-full ${styles[value]}`}
    >
      {value}
    </span>
  );
};

export default function SAP_Applications() {
  const [activeTab, setActiveTab] = useState("Active");
  const navigate = useNavigate();

  return (
    <div className="">
      {/* Header */}
      <div className="p-4 ">
        <h2 className="text-2xl font-inter font-bold text-[#5B2D8B]">
          {activeTab} Application
        </h2>
      </div>
      <div className="font-inter bg-white rounded-2xl shadow-sm border border-gray-200">
        {/* Tabs */}
        <div className="flex gap-6 px-6 mt-4 border-b">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`pb-3 text-sm font-medium relative ${
                activeTab === tab
                  ? "text-[#5B2D8B]"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            >
              {tab}
              {activeTab === tab && (
                <span className="absolute left-0 -bottom-[1px] w-full h-[4px] bg-[#5B2D8B]" />
              )}
            </button>
          ))}
        </div>

        {/* Table */}
        <div className="p-6">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-[#FDF3FD] rounded-lg text-left text-gray-900 font-semibold">
                  <th className="px-4 py-3 ">Courses</th>
                  <th className="px-4 py-3 ">University</th>

                  {activeTab !== "Active" && (
                    <th className="px-4 py-3 ">Intake</th>
                  )}

                  {activeTab === "Offers" && (
                    <th className="px-4 py-3 ">Offer Expiry</th>
                  )}

                  {activeTab !== "Cancelled" && (
                    <th className="px-4 py-3 ">Application Fee</th>
                  )}

                  <th className="px-4 py-3 ">
                    {activeTab === "Cancelled" ? "Status" : "Stage"}
                  </th>
                </tr>
              </thead>

              <tbody>
                {applications[activeTab].map((item, idx) => (
                  <tr
                    key={idx}
                    className="border-b last:border-none hover:bg-gray-50"
                  >
                    <td
                      cursor="pointer"
                      onClick={() => navigate("/sap/applications-details")}
                      className="px-4 py-4 text-[#0B3892] font-medium"
                    >
                      {item.course}
                    </td>

                    <td className="px-4 py-4">
                      <div className="flex items-center gap-2">
                        <img
                          src={`https://flagcdn.com/w20/${
                            countryCodeMap[item.country]
                          }.png`}
                          alt={item.country}                                                                           
                          className="w-5 h-5 rounded-full object-cover"
                        />
                        <div>
                          <p className="font-medium text-gray-800">
                            {item.university}
                          </p>
                          <p className="text-xs text-gray-500">
                            {item.country}
                          </p>
                        </div>
                      </div>
                    </td>
                  
                    {activeTab !== "Active" && (
                      <td className="px-4 py-4">{item.intake}</td>
                    )}

                    {activeTab === "Offers" && (
                      <td className="px-4 py-4">{item.expiry}</td>
                    )}                                         

                    {activeTab !== "Cancelled" && (
                      <td className="px-4 py-4">
                        <FeeBadge value={item.fee} />
                      </td>
                    )}

                    <td className="px-4 py-4 text-gray-700">
                      {item.stage || item.status}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
